import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import './pages.css';

const Privacy = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="gpt3__pages gradient__bg">
            <div className="gpt3__pages-back">
                <Link to="/">
                    <FiArrowLeft /> Back to Home
                </Link>
            </div>
            <div className="gpt3__pages-content">
                <h1 className="gradient__text">Privacy Policy</h1>
                <p>Last updated: February 28, 2026</p>
                
                <h2>1. Information Collection</h2>
                <p>We collect minimal information necessary to provide our ECU tuning and file processing services. This may include contact details and technical data related to the ECU files you upload.</p>
                
                <h2>2. Data Usage</h2>
                <p>Your data is used solely for processing your requests and providing technical support. We do not sell or share your personal information with third parties for marketing purposes.</p>
                
                <h2>3. Security</h2>
                <p>We implement industry-standard security measures to protect your information and files. All binary data is processed securely and handled with confidentiality.</p>
                
                <h2>4. Cookies</h2>
                <p>Our website may use cookies to improve user experience and site functionality. You can manage cookie preferences in your browser settings.</p>
                
                <h2>5. Changes to Privacy Policy</h2>
                <p>We may update this policy periodically. Any changes will be reflected on this page with an updated modification date.</p>
            </div>
        </div>
    );
};

export default Privacy;
